/**
 * An account ID is a typeof string that is prefixed with either P (production)
 * or T (test) and is followed by the internal account ID.
 *
 * The internal account ID is an uppercased numeric string that is 8 characters long.
 * The account ID is case sensitive, so it must be in the format of P12345678 or T12345678.
 *
 * An account ID corresponds to a partner account when the internal account ID contains a
 * padding of 0s followed by 3 digits. 11100000 is a partner, while 11100001 is a merchant of
 * the partner.
 */

export const isInternalAccountId = (value: any) => {
    if (typeof value !== "string") {
        return false;
    }
    const regex = /^[0-9]{8}$/;
    return regex.test(value);
};

export const isAccountId = (value: any) => {
    if (typeof value !== "string") {
        return false;
    }
    const regex = /^[PT][0-9]{8}$/;
    return regex.test(value);
};

export const isPartnerAccountId = (value: any) => {
    if (!isAccountId(value)) {
        return false;
    }
    const internalAccountId = value.substring(1);
    const regex = /^[0-9]{3}00000$/;
    return regex.test(internalAccountId);
};

export const validateAccountId = (message: string) => {
    return (value: any) => {
        const isValid = isAccountId(value);
        if (!isValid) {
            return message;
        }
    };
};
